import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * İki kullanıcı arasındaki mevcut sohbet odasını bulur.
 * Eğer oda yoksa, standart (alfabetik sıralı) formatta yeni bir ID döner.
 * Sistemde farklı algoritmalardan kaynaklanan (A_B vs B_A) kopya odalar varsa,
 * en son mesaj atılan odayı seçer. Sadece bir tanesi varsa onu seçer.
 * Her ikisi de yoksa varsayılan olarak (küçükUID_büyükUID) oluşturur.
 */
export const resolveChatRoomId = async (uid1, uid2) => {
    if (!uid1 || !uid2) return null;
    
    // Kotlin'in if (uid1 < uid2) yapısına uyarlamak için lexicographical karşılaştırma
    const isSmallerFirst = uid1 < uid2;
    const idA = isSmallerFirst ? `${uid1}_${uid2}` : `${uid2}_${uid1}`;
    const idB = isSmallerFirst ? `${uid2}_${uid1}` : `${uid1}_${uid2}`;
    
    try {
        const docA = await getDoc(doc(db, 'chatRooms', idA));
        const docB = await getDoc(doc(db, 'chatRooms', idB));
        
        if (docA.exists() && docB.exists()) {
            const timeA = docA.data()?.lastMessageAt?.toMillis() || 0;
            const timeB = docB.data()?.lastMessageAt?.toMillis() || 0;
            return timeA > timeB ? idA : idB;
        }
        
        if (docA.exists()) return idA;
        if (docB.exists()) return idB;
        
    } catch (e) {
        console.error("Error resolving chatRoomId", e);
    }
    
    // Varsayılan: WhatsApp stili (küçük_büyük)
    return idA;
};
